// extracted by mini-css-extract-plugin
module.exports = {"PageHolder":"AddPage_PageHolder__2PuqH","Pageinfo":"AddPage_Pageinfo__pUE9k","ShowPageStyle":"AddPage_ShowPageStyle__2tBLa"};